import React, { Component } from 'react';


const styleLogo = {
  width: '100%',
  height: '100%',
  objectFit: 'contain',
}

const positionDiv = {
  position: 'relative'
}


export default class HeroScreen extends Component {
  render() {
    return (
      <div className="hero" id="homeImage">
        <div className="container hero-flex">
          <div className="row">
            <div className="col-6 col-md-4 logo-column">
              <img style={styleLogo} src="/images/logo-white.png" alt="Logotipo freguesia"></img>
            </div>
          </div>
          <div className="row div-bottom-mobile">
            
            <div className="col-12 col-md-6 no-padding-left-elements">
              <h1>Mais do que se vê</h1>
              <p className="hero-details" >Bem vindo ao Sabugueiro. <br/> Aqui o ar é puro e renovador. <br/> Quase se tocam as estrelas com as mãos. <br/> A água refresca e revitaliza como em mais nenhum lugar.</p>
            </div>
            <div style={positionDiv} className="col-12 col-md-4 offset-md-2">
              <div className="hero-div-mouse">
                
                  <div className="scroll-downs">
                    <div className="mousey">
                      <div className="scroller"></div>
                    </div>
                  </div>
                  <p className="see-more-hero">Saiba Mais</p>
                  
                </div>
            </div>
            
          </div>
        </div>
      </div>
    )
  }
}
